export default __webpack_public_path__ + "static/media/ai-write-2.8cc5c624.webp";